import React, { useState, useContext, useEffect } from 'react';
import { AppContext } from '../../context/context';
import { Table, Button, Pagination, Select, Group, TextInput, Grid, Divider, Chip } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faCircleInfo, faPause, faCircleCheck, faRoadBarrier, faCircle } from '@fortawesome/free-solid-svg-icons';

const DataTableInterlineales = ({ data, setId, conteocr, conteoh, conteov, conteocs }) => {

    const appcontext = useContext(AppContext);
    const columns = React.useMemo(() => {
        if (data.length === 0) return [];
        var headers = ["FECHA VUELO", "EJECUTIVO", "# GUIA", "QTY", "WEIGHT", "CM3", "TONS", "DESC", "SCH", "DIMS", "FORWARDER", "OPT"]
        //carriers
        headers.push("CARRIER ");
        for (let i = 2; i < conteocr; i++)
            headers.push("CARRIER " + i);

        headers.push("ORIGIN");
        //hubs
        headers.push("HUBS DEP");
        for (let i = 1; i < conteoh; i++)
            headers.push("HUBS " + i);

        headers.push("DEST");
        ///vuelos
        headers.push("VUELO ");
        for (let i = 2; i < conteov; i++)
            headers.push("VUELO " + i);

        //conexions
        headers.push("CNX DETAILS");
        for (let i = 2; i < conteocs; i++)
            headers.push("CNX DETAILS " + i);

        headers.push("REMARKS");
        headers.push("TIPO");
        return headers;
    }, [data]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const [filter, setFilter] = useState('');


    /*const filteredData = data.filter(item =>
        Object.values(item).some(value =>
            value != null && value.toString().trim() !== '' && value.toString().toLowerCase().includes(filter.toLowerCase())
        )
    );*/
    // State for filtered data
    const [filteredData, setFilteredData] = useState(data);

    // State for column filters
    const [filters, setFilters] = useState({});

    useEffect(() => {
        setFilteredData(data);
        setFilters({});
    }, [data]);

    // Handle filtering based on column
    const handleFilterChange = (column, value) => {
        const updatedFilters = { ...filters, [column]: value };
        setFilters(updatedFilters);

        // Apply filtering to the data
        const newFilteredData = data.filter((row) => {
            return Object.keys(updatedFilters).every((key) => {
                const filterValue = updatedFilters[key].toLowerCase();
                const cellValue = row[key] ? row[key].toString().toLowerCase() : '';

                // Only include rows where the cell value matches the filter
                return filterValue === '' || cellValue.includes(filterValue);
            });
        });


        setFilteredData(newFilteredData);
    };


    const totalRecords = filteredData.length;
    const totalPages = Math.ceil(filteredData.length / pageSize);
    const startIndex = (page - 1) * pageSize;
    const endIndex = Math.min(startIndex + pageSize - 1, totalRecords);
    const paginatedData = filteredData.slice(startIndex, startIndex + pageSize);


    const handleEdit = (id) => {
        setId(id);
        appcontext.setStatusFNR(true);
    }

    const handleInfo = (id) => {
        setId(id);
        appcontext.setStatusFNI(true);
    }
    return (
        <>
            {/* Render filters for each column dynamically  <Group justify="space-between">
                <Select
                    label="Registros por pagina"
                    value={pageSize.toString()}
                    onChange={(value) => setPageSize(parseInt(value, 10))}
                    data={[5, 10, 20, 30, 50].map((size) => ({ value: size.toString(), label: size.toString() }))}
                />
                <TextInput
                    label="Buscar"
                    placeholder="Buscar..."
                    value={filter}
                    onChange={(event) => { setFilter(event.currentTarget.value); setPage(1) }}
                />
            </Group>
            */}
            <Group justify="space-between">
                {/* Render filters for each column dynamically */}
                <Select
                    label="Registros por pagina"
                    value={pageSize.toString()}
                    onChange={(value) => setPageSize(parseInt(value, 10))}
                    data={[5, 10, 20, 30, 50].map((size) => ({ value: size.toString(), label: size.toString() }))}
                />


            </Group>
            <Grid.Col span={12}>
                <Divider size="sm" />
            </Grid.Col>

            <Table.ScrollContainer minWidth={500} type="native">
                <Table id="example" striped highlightOnHover withTableBorder>
                    <Table.Thead >
                        <Table.Tr>
                            <Table.Th style={{ backgroundColor: '#035cf7', color: '#F2F2F0' }}>
                                ACCIONES
                            </Table.Th>
                            {columns.map(column => (
                                <Table.Th key={column} style={{ backgroundColor: '#035cf7', color: '#F2F2F0', whiteSpace: 'nowrap', minWidth: '200px' }}>
                                    {column === 'FECHA VUELO'?"FECHA CREACION":column}
                                </Table.Th>
                            ))}
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                        {
                            paginatedData.map((row, rowIndex) => (
                                <Table.Tr key={rowIndex}>
                                    <Table.Td>
                                        <Button.Group>
                                            <Button variant="outline" color='#FCC732' onClick={() => { handleEdit(row["id"]) }}><FontAwesomeIcon icon={faPen} /></Button>
                                            <Button variant="outline" color='#035CF7' onClick={() => { handleInfo(row["id"]) }}><FontAwesomeIcon icon={faCircleInfo} /></Button>
                                        </Button.Group>
                                    </Table.Td>
                                    {columns.map(column => {
                                        if (column.includes("CNX DETAIL")) {
                                            if (row[column] != null && row[column] == 'Pending connection') {
                                                return (
                                                    <Table.Td key={column} style={{ whiteSpace: 'nowrap' }}>
                                                        <Chip checked={true} color={'#0070c0'} icon={<FontAwesomeIcon icon={faPause} />}>
                                                            {row[column]}
                                                        </Chip>
                                                    </Table.Td>
                                                );
                                            } else if (row[column] != null && row[column] == 'At connection point') {
                                                return (
                                                    <Table.Td key={column} style={{ whiteSpace: 'nowrap' }}>
                                                        <Chip checked={true} color={'#00af50'} icon={<FontAwesomeIcon icon={faCircleCheck} />}>
                                                            {row[column]}
                                                        </Chip>
                                                    </Table.Td>
                                                );
                                            }
                                            else if (row[column] != null && row[column] == 'In Transit') {
                                                return (
                                                    <Table.Td key={column} style={{ whiteSpace: 'nowrap' }}>
                                                        <Chip checked={true} color={'#7030a0'} icon={<FontAwesomeIcon icon={faRoadBarrier} />}>
                                                            {row[column]}
                                                        </Chip>
                                                    </Table.Td>
                                                );
                                            }
                                            else if (row[column] != null && row[column] == 'At destination') {
                                                return (
                                                    <Table.Td key={column} style={{ whiteSpace: 'nowrap' }}>
                                                        <Chip checked={true} color={'#012260'}>
                                                            {row[column]}
                                                        </Chip>
                                                    </Table.Td>
                                                );
                                            }
                                            else if (row[column] != null) {
                                                return (
                                                    <Table.Td key={column} style={{ whiteSpace: 'nowrap' }}>
                                                        <Chip checked={true} color={'gray'} icon={<FontAwesomeIcon icon={faCircle} />}>
                                                            {row[column]}
                                                        </Chip>
                                                    </Table.Td>
                                                );
                                            }
                                            else {
                                                return (
                                                    <Table.Td key={column} style={{ whiteSpace: 'nowrap' }}>

                                                    </Table.Td>
                                                );
                                            }
                                        }

                                        else
                                            return (
                                                <Table.Td key={column} style={{ whiteSpace: 'nowrap' }}>
                                                    {row[column]}
                                                </Table.Td>
                                            );
                                    }
                                    )}
                                </Table.Tr>
                            ))
                        }
                    </Table.Tbody>
                    <Table.Tfoot>
                        <Table.Tr>
                            <Table.Th>
                                <TextInput
                                    disabled
                                />
                            </Table.Th>
                            {columns.map((column) => (
                                <Table.Th  key={column}>
                                    <TextInput key={column}
                                        placeholder={`Filter by ${column}`}
                                        value={filters[column] || ''}
                                        onChange={(e) => handleFilterChange(column, e.target.value)}
                                    />
                                </Table.Th>
                            ))}
                        </Table.Tr>
                    </Table.Tfoot>
                </Table>
            </Table.ScrollContainer>
            <Grid.Col span={12}>
                <Divider size="sm" />
            </Grid.Col>
            <Group justify="space-between">
                <Pagination
                    total={totalPages}
                    page={page}
                    onChange={setPage}
                    styles={{ control: { margin: '0 5px' } }}
                />
                <div style={{ marginTop: '10px' }}>
                    Showing {startIndex + 1} to {(endIndex + 1) > totalRecords ? totalRecords : endIndex + 1} of {totalRecords} entries
                </div>
            </Group>

        </>
    );
};

export default DataTableInterlineales;